<template>
  <el-dialog
    :visible.sync="localVisible"
    @close="handleClose"
    width="80%"
    top="5vh"
    custom-class="detail-dialog"
  >
    <!-- 基本信息 -->
    <el-descriptions :column="2" border>
      <el-descriptions-item label="往来单位">{{
        localDetail.companyName
      }}</el-descriptions-item>
      <el-descriptions-item label="粮食品种">{{
        localDetail.grainName
      }}</el-descriptions-item>
      <el-descriptions-item label="粮食等级">{{
        localDetail.grainLevel
      }}</el-descriptions-item>
      <el-descriptions-item label="预约数量"
        >{{ localDetail.appointmentDispatchWeight }}KG</el-descriptions-item
      >
      <el-descriptions-item label="预约出库时间">{{
        localDetail.appointmentDispatchTime
      }}</el-descriptions-item>
    </el-descriptions>

    <!-- 出库详单表格 -->
    <div
      class="table-title"
      style="
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 500;
        margin-top: 10px;
      "
    >
      出库详单
    </div>
    <el-table :data="detailList" border style="margin-top: 20px" height="400">
      <el-table-column prop="number" label="单据号" width="160" />
      <el-table-column prop="carNo" label="车牌号" />
      <el-table-column prop="driverName" label="司机" />
      <el-table-column prop="companyName" label="往来单位" />
      <el-table-column prop="grainName" label="粮食品种" />
      <el-table-column prop="grainLevel" label="粮食等级" />
      <el-table-column prop="loadStoreName" label="出库仓库" />
      <el-table-column prop="createTime" label="登记时间" width="160" />
      <el-table-column prop="statusName" label="出库进度"> </el-table-column>
      <el-table-column prop="dataStatus" label="数据状态">
        <template #default="{ row }">
          <el-tag v-if="row.dataStatus === 0" type="success">正常</el-tag>
          <el-tag v-else-if="row.dataStatus === 1" type="danger">异常</el-tag>
          <el-tag v-else type="success">正常</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { stockOutOrderAppointmentDetail } from "@/api/warehousingService";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detailId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localVisible: this.visible,
      localDetail: {},
      loading: false,
      detailList: [],
      statusTagMap: {
        1: "warning",
        2: "success",
        3: "info",
      },
      statusLabels: {
        1: "进行中",
        2: "已完成",
        3: "已取消",
      },
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
    detailId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getDetailData();
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },

    //获取查看出库预约详情数据
    async getDetailData() {
      try {
        const res = await stockOutOrderAppointmentDetail({ id: this.detailId });
        this.localDetail = res.data;
        this.detailList = res.data.stockOutOrderItemList;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 80vh;
}

::v-deep .detail-dialog {
  .el-dialog__body {
    padding: 20px;
    height: calc(90vh - 110px);
  }
}
</style>
